var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8337 8.33398V3.33398M13.3337 5.83398H18.3337M13.3337 17.5007V16.5007C13.3337 15.1005 13.3337 14.4005 13.0612 13.8657C12.8215 13.3953 12.439 13.0128 11.9686 12.7731C11.4339 12.5007 10.7338 12.5007 9.33366 12.5007H5.66699C4.26686 12.5007 3.5668 12.5007 3.03202 12.7731C2.56161 13.0128 2.17916 13.3953 1.93948 13.8657C1.66699 14.4005 1.66699 15.1005 1.66699 16.5007V17.5007M10.417 6.25065C10.417 7.86148 9.11116 9.16732 7.50033 9.16732C5.8895 9.16732 4.58366 7.86148 4.58366 6.25065C4.58366 4.63982 5.8895 3.33398 7.50033 3.33398C9.11116 3.33398 10.417 4.63982 10.417 6.25065Z",
    stroke: "#0265DC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntake);
export default __webpack_public_path__ + "static/media/intake.1e29e8985095725f76f933ae891f2265.svg";
export { ForwardRef as ReactComponent };